import { Box, Typography, Card, CardContent, Stack } from '@mui/material';
import { LinkOutlined as LinkIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import { image } from '../../lib/format';
import Badge from '../../components/Badge';
import VerifiedBadge from './VerifiedBadge';

const DEFAULT_THUMBNAILS = [
  image('photo-1495474472287-4d71bcdd2085', 400, 300),
  image('photo-1509042239860-f550ce710b93', 400, 300),
  image('photo-1447933601403-0c6688de566e', 400, 300),
];

function CampaignCard({ campaign }) {
  return (
    <Card sx={{ borderRadius: 4, boxShadow: '0 20px 60px rgba(20, 10, 50, 0.12)', border: '1px solid rgba(20, 10, 50, 0.06)' }}>
      <CardContent sx={{ p: { xs: 2.5, sm: 3.5 } }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ justifyContent: 'space-between', mb: 2.5 }}>
          <Box>
            <Typography variant="h5" fontWeight={700}>
              {campaign.name}
            </Typography>
            <Typography color="text.secondary">
              {campaign.brand} · {campaign.date}
            </Typography>
          </Box>
          <VerifiedBadge label={`Verified by ${campaign.verifiedCount} collaborators`} />
        </Stack>

        <Stack direction="row" spacing={1.5} sx={{ mb: 2.5 }}>
          {(campaign.images || DEFAULT_THUMBNAILS).map((src) => (
            <Box
              key={src}
              component="img"
              src={src}
              alt=""
              sx={{ flex: 1, height: { xs: 64, sm: 96 }, borderRadius: 2, objectFit: 'cover' }}
            />
          ))}
        </Stack>

        <Typography variant="overline" color="text.secondary">
          Deliverables
        </Typography>
        <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap', mb: 2 }}>
          {campaign.deliverables.map((item) => (
            <Badge key={item}>{item}</Badge>
          ))}
        </Stack>

        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 2 }}>
          <TrendingUpIcon sx={{ fontSize: 18, color: 'primary.main' }} />
          <Typography variant="body2" fontWeight={600}>
            {campaign.results}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <LinkIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            {campaign.contentLinks} published links attached
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default CampaignCard;
